const popoverController = require('../../../lib/controllers/popover')

module.exports = {
    model: {
        dataJSON: {},

        location:               null,
        locationUrl:            null,
        locationGeneratedUrl:   null,

        config: {
            // separatedFieldCodes: {
            //     location:                'location',
            //     locationUrl:             'locationUrl',
            //     locationGeneratedUrl:    'locationGeneratedUrl',
            // },

            fields: {
                location: {
                    placeholderKey: 'form.fields.location.location.placeholder',
                },
                locationGeneratedUrl: {
                    urlBase: 'https://www.google.com/maps/search/{location}',
                },
                locationUrl: {

                },
            },
        }
    },

    events: {
        controls: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.stopImmediatePropagation();
                const self = event.data.component;
                const $target = $(event.target).closest('button');
                const fieldType = $target.data('fieldType')
                const buttonContext = $target.data('buttonContext')

                if(fieldType === 'showEdit' && buttonContext === 'locationOptions'){
                    self.showEdit_locationOptions($target, `button[data-field-type="${fieldType}"][data-button-context="${buttonContext}"]`)
                } else if(fieldType === 'openLocation' && buttonContext === 'location'){
                    self.openLocation()
                }
            }
        },
    },

    methods: {
        showEdit_locationOptions($button, triggerSelector){
            return this.performAndStoreAction(
                'showEdit_locationOptions_inEffect',
                this.prepareAction(popoverController.getPopoverAction($button, triggerSelector), undefined, undefined, {
                    source: {
                        container: {
                            componentData: {
                                config: {
                                    orientation: 'SE-NE',
                                    autoOpen: true,
                                    preventFirstFocusOut: true,
                                    distance: {
                                        y: '.5em'
                                    }
                                }
                            }
                        },
                        content: {
                            componentData: {
                                component: [
                                    'base',
                                    'form',
                                    'fields',
                                    'locationOptions',
                                ],
                                resourceData: {
                                    data: {
                                        attributes: {
                                            ...(this.model.dataJSON || {})
                                        }
                                    }
                                },
                                model: {
                                    config: {
                                        fields: (this.model.config || {}).fields || {}
                                    }
                                }
                            }
                        }
                    }
                })
            )
        },

        prepare(){
            this.initConfig()
        },

        initConfig(){
            const fieldConfig = this.model.config || {}
            const lguConfig = (fieldConfig.fields || {}).locationGeneratedUrl || {}
            if(lguConfig.urlBase){
                lguConfig.urlBase = this.getSanitizeUrl(lguConfig.urlBase)
            }
        },

        getSanitizeUrl(url){
            if(url){
                url = String(url).trim()
                const matches = String(url).match(/^(\s*https?:?\/\/)?([^:]+)(:[^:/]+)?$/)
                if(matches === null || !matches[1]){
                    url = `https://${url}`
                }
            }

            return url
        },

        generateUrl(){
            const fieldConfig = this.model.config || {}

            if(this.model.location && fieldConfig.fields.locationGeneratedUrl.urlBase){
                this.model.locationGeneratedUrl = String(fieldConfig.fields.locationGeneratedUrl.urlBase || '').replace(/\{location\}/g, encodeURI(this.model.location))
            } else {
                this.model.locationGeneratedUrl = null
            }
        },

        openLocation(){
            const url = this.model.locationUrl || this.model.locationGeneratedUrl
            if(url){
                window.open(url, '_blank')
            } else {
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:form.fields.location.missingUrl'
                        }
                    })
                )
            }
        },

        onChange(location, locationUrl, forceValueChanged = false){
            if(location !== undefined){
                location = location || null

                if(location !== this.model.location){
                    this.model.location = location
                    forceValueChanged = true
                    this.generateUrl()
                }
                // auto-correction: if a field config changes one might update the locationGeneratedUrl
                else {
                    const lastLocationGeneratedUrl = '' + this.model.locationGeneratedUrl
                    this.generateUrl()
                    if(lastLocationGeneratedUrl !== this.model.locationGeneratedUrl){
                        forceValueChanged = true
                    }
                }
            }

            if(locationUrl !== undefined){
                locationUrl = this.getSanitizeUrl(locationUrl || null)

                if(locationUrl !== this.model.locationUrl){
                    this.model.locationUrl = locationUrl
                    forceValueChanged = true
                }
            }

            if(forceValueChanged){
                this.triggerClosest('onChildChanged', {
                    fieldCode: this.model.fieldCode,
                    value: {
                        location:               this.model.location,
                        locationUrl:            this.model.locationUrl,
                        locationGeneratedUrl:   this.model.locationGeneratedUrl,
                    }
                });
            }
        },

        onBeforeRender: function(){
            const initData = this.model.dataJSON || {}
            this.model.location             = initData.location || null
            this.model.locationUrl          = initData.locationUrl || null
            this.model.locationGeneratedUrl = initData.locationGeneratedUrl || null
        },
    },

    hooks: {
        postAttach($element, options){
            // correct values automatically if necessary
            if(!options.refresh && !this.model.config.disabled){
                this.onChange(this.model.location)
            }
        },

        onChildChanged($element, options){
            if(options.fieldCode === 'location'){
                this.onChange(options.value)
            } else if(options.fieldCode === 'locationUrl'){
                this.onChange(undefined, options.value)
            }
        }
    }
}